import {
  Box,
  ButtonBase, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DisplayFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import StyledBox from './styles';
import useDisplayCards from './useDisplayCards';

interface DisplayResumeProps {
  displays: DisplayFieldsFragment[];
}
export default function SummaryDisplay(props: DisplayResumeProps) {
  const { displays } = props;
  const { t } = useTranslation('session');
  const { t: tCommon } = useTranslation('common');
  const { cards, seeMore } = useDisplayCards(displays);

  if (!cards.length) return null;
  return (
    <StyledBox>
      <Typography variant="subtitle1">
        {t('details.content')}
      </Typography>
      <Typography variant="subtitle2">
        {t('details.cards.title')}
      </Typography>
      <Box className="content">
        <Box className="cards">
          {cards?.map((display) => (
            <Box key={display.card.id}>
              <Typography title={display.card.title}>
                {display.card.title}
              </Typography>
              <Typography key={display.card.id}>
                {t('list.displays', { count: display.count })}
              </Typography>
            </Box>
          ))}
        </Box>
        {seeMore && (
          <ButtonBase color="primary" onClick={() => seeMore.toggle()} className="seeMore">
            {seeMore.displayAll ? tCommon('See Less') : tCommon('See More')}
          </ButtonBase>
        )}
      </Box>
    </StyledBox>
  );
}
